import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'LostPassword',
  data () {
    return {
      theme: process.env.Theme,
      version: process.env.VersionApp,
      email: null
    }
  },
  computed: {
    IsThemeSDS: function () {
      var result = false
      if (this.theme === 'SDS') {
        result = true
      }
      return result
    },
    IsThemeCOTEXO: function () {
      var result = false
      if (this.theme === 'COTEXO') {
        result = true
      }
      return result
    },
    classBgImg: function () {
      var result = 'bg-img-acelerauto'
      if (this.theme === 'SDS') {
        result = 'bg-img'
      } else if (this.theme === 'COTEXO') {
        result = 'bg-img-cotexo'
      }
      return result
    }
  },
  methods: {
    onResetPassword () {
      if (this.email) {
        toast.success('<strong>Senha redefinida com sucesso!</strong><br><br>As informações foram enviadas para seu email!')
        this.email = null
      } else {
        toast.error('ATENÇÃO! Informe seu email')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/public/password/lost/LostPassword.js